import React, { useState, useEffect } from "react";
import { loadServiceItems } from "../../utils/helper-function"
import { ItemMenu } from "../../components/Service";
import Service from "../../models/Service";

const Drinks: React.FC = () => {
  const [drinks, setDrinks] = useState<Service[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const loadDrinks = async () => {
      const [drinks, categories] = await loadServiceItems("drinks");

      //  const location = localStorage.getItem("loungeLocation");

      //  console.log(location);

      setDrinks(drinks);
      setCategories(categories);
    };
    loadDrinks();
  }, []);
  
  return (
    <ItemMenu title="Drinks" items={drinks} categories={categories} />
  );
};

export default Drinks;